<template>
  <v-container fluid>
    <PageHeading
      :text="$t('pages-name.parent.media-library')"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn small outlined color="primary" class="mx-2 mt-2" @click="$refs.dialog.open()">
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          {{ $t('page-media-library.btn-upload') }}
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridMediaLibrary ref="grid" />
      </v-col>
    </v-row>
    <UploadDialog
      ref="dialog"
      :multiple="true"
      @update-grid="refresh"
    />
  </v-container>
</template>

<script>
import GridMediaLibrary from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'
import UploadDialog from './upload-dialog'

export default {
  name: 'media-library',
  components: {
    PageHeading,
    GridMediaLibrary,
    UploadDialog
  },
  mixins: [gridPageInterface],
  metaInfo () {
    return {
      title: this.$t('pages-name.parent.media-library')
    }
  },
  methods: {
    refresh () {
      this.$refs.grid.refetch()
    }
  }
}
</script>
